// import { useState } from 'react';

// Services
import { type HeaderType } from '@/services/header/headerService';

// Hooks
import useResponsive from '@/hooks/useResponsive';

// Components
// import LanguageModal from '@/components/molecules/LanguageModal/LanguageModal';
import Menu from './Menu/Menu';
import BurgerMenu from './BurgerMenu/BurgerMenu';

// Styles
import styles from './Header.module.css';

type HeaderProps = {
  color: 'light' | 'dark';
  header: HeaderType;
}

function Header({
  color = 'dark',
  header,
}: HeaderProps) {
  const { isMobile } = useResponsive();

  if (!header) {
    return null;
  }

  const { logoBlack, logoWhite, logoMobile, menu, loginButton, registerButton, support } = header;

  return (
    <header
      className={`
        ${styles.header}
        ${styles[`header-${color}`]}
      `}
    >
      {
        isMobile ? (
          <BurgerMenu
            logo={logoMobile}
            menu={menu}
            loginButton={loginButton}
            registerButton={registerButton}
            support={support}
          />
        ) : (
          <Menu
            logo={color === 'dark' ? logoWhite : logoBlack}
            menu={menu}
            loginButton={loginButton}
            registerButton={registerButton}
            color={color}
          />
        )
      }
      {/* <LanguageModal /> */}
    </header>
  );
}

export default Header;